/*
 * @Date: 2022-08-15 14:59:17
 * @LastEditTime: 2022-08-16 10:13:33
 * @Description:
 */
import { net_collection } from "@/api/http";
export const API_DisplayCollectionDocumentsEditScene = (...params) =>
  net_collection.post("/api/STDSDC04C01/DisplayCollectionDocumentsEditScene", ...params);
